/**
 * Devuelve '#000' o '#fff' según qué color contrasta mejor con el fondo.
 * Usa fórmula simplificada de luminancia perceptual (coef. ITU-R BT.601).
 */
export function getContrastColor(hexBackground: string): string {
  const hex = hexBackground.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? '#000' : '#fff';
}
